module.exports = require("timers/promises");